angular.module('quattro.core.form-helper', [
    'quattro.core.form-helper.checkval',
    'quattro.core.info-memo',
    'quattro.core.ng-indeterminate',
]);
